import { useDispatch, useSelector } from "react-redux";
import moment from "jalali-moment";
import { useState } from "react";
import { Set } from "../../../Request";
import { useLocation } from "react-router-dom";

export const useSupport = () => {
  const { popUp, user } = useSelector(state => state);
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    step: 1,
  });
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const close = () => {
    let obj = {
      ...popUp,
      status: false,
      isCall: false,
    };
    dispatch({
      local_storage: {
        key: "popUp",
        value: {
          ...obj,
        },
      },
      type: "SET",
      payload: {
        popUp: {
          ...obj,
        },
      },
    });
  };
  const store = async () => {
    setLoading(true);
    await Set({
      url: "/problem/store",
      data: { ...form, path: location.pathname },
    }).then(() => {
      setLoading(false);
      close(true);
    });
  };
  return {
    popUp,
    dispatch,
    close,
    form,
    store,
    setForm,
    loading,
    setLoading,
    user,
  };
};
